import { storage } from "../schmucklicloud";
import axios from "axios";
import Config from "../config";

class OAuth {
    settings = undefined;
    setting_name = undefined;
    id = undefined;
    tile_config = undefined;
    refresh_token_tries = 0;

    /**
     * Creates an OAuth instance, where you can get simply the access token and refresh the token.
     * @param {Number} tile_id The number of the ID provided by the schmuckliCloud service.
     * @param {String} setting_name The name of the settings element, where the OAuth button is placed.
     */
    constructor(tile_id, setting_name) {
        this.id = tile_id;
        this.setting_name = setting_name;
    }

    getSettings() {
        return new Promise(function (resolve) {
            if (this.settings === undefined) {
                storage.getById("tiles", this.id).then(function (tile) {
                    if (tile.isOK) {
                        axios.get(Config.DASHBOARD_API_ENDPOINT + "/config.php").then(function (tile_configs) {
                            if (tile_configs.status === 200) {
                                this.settings = JSON.parse(tile.data.data.settings);
                                
                                //Select the tile config
                                tile_configs.data.tiles.forEach(function(curr_tile_config) {
                                    if (curr_tile_config.path === tile.data.data.path) {
                                        this.tile_config = curr_tile_config;
                                    }
                                }.bind(this));

                                resolve(this.settings);
                            }
                        }.bind(this));
                    } else {
                        throw new Error("There was an error searching for the tile id.");
                    }
                }.bind(this));
            } else {
                resolve(this.settings);
            }
        }.bind(this));
    }

    async getAccessToken() {
        var settings = await this.getSettings();
        return JSON.parse(settings.oauth).access_token;
    }

    async refreshAccessToken() {
        var data_settings = await this.getSettings(); //Storage of access_token, refresh_token
        var oauth_settings; //Storage of the config settings selected below

        this.tile_config.settings.forEach(function (curr_setting) {
            if (curr_setting.name === this.setting_name) {
                oauth_settings = curr_setting;
            }
        }.bind(this));

        return await new Promise(function(resolve, reject) {
            axios.get(Config.DASHBOARD_API_ENDPOINT + "oauth_refresh.php", {
                params: {
                    client_id: oauth_settings.client_id,
                    client_secret: oauth_settings.client_secret,
                    url: oauth_settings.oauth_auth_refresh_token_url,
                    type: oauth_settings.oauth_type,
                    refresh_token: JSON.parse(data_settings[this.setting_name]).refresh_token
                }
            }).then(async function (response) {
                if(response.status === 200) {
                    var settings = await this.getSettings();

                    var data = JSON.parse(settings[this.setting_name]);
                    if(response.data.access_token !== undefined && response.data.access_token !== "" && response.data.access_token !== null) {
                        data.access_token = response.data.access_token;
                    } else {
                        reject("No access token received");
                    }
                    
                    //Checks if the response has sent a new refresh token, otherwise keep the old one.
                    if(response.data.refresh_token !== undefined && response.data.refresh_token !== "" && response.data.refresh_token !== null) {
                        data.refresh_token = response.data.refresh_token;
                    }

                    settings[this.setting_name] = JSON.stringify(data);
                    
                    storage.update("tiles", this.id, {settings: JSON.stringify(settings)}).then(function(update_settings) {
                        if (update_settings.isOK) {
                            this.settings = undefined;
                            resolve(response.data);
                        }
                    }.bind(this));
                    
                } else {
                    resolve(false);
                }
            }.bind(this));
        }.bind(this));
    }

    request(url, method, body) {
        if(method === undefined) {
          method = "GET"
        }
  
        return new Promise(async function(resolve) {
          axios({
            method: "GET",
            url: Config.DASHBOARD_API_ENDPOINT + "oauth_access.php",
            params: {
                url: url,
                method: method,
                body: body,
                access_token: await this.getAccessToken()
            },
          }).then(async function(response) {
            switch (response.status) {
                case 401:
                    if (this.refresh_token_tries === 0) {
                        await this.refreshAccessToken();
                        this.refresh_token_tries++;
                        this.request(url, method);
                    } else {
                        resolve(false);
                    }
                    break;
                default:
                    resolve(response);
                    break;
            }
          }.bind(this)).catch(async function () {
            if (this.refresh_token_tries === 0) {
              await this.refreshAccessToken();
              this.refresh_token_tries++;
              this.request(url, method);
            } else {
              resolve(false);
            }
          }.bind(this));
        }.bind(this));
      }
}

export default OAuth;